import InlineSvg from "vue-inline-svg";
import gql from "graphql-tag";
import feedApi from "../../../services/feed/feed";
import GridView from "@/views/dashboard/posts/GridView";
import TableView from "@/views/dashboard/posts/TableView";

const feedApiService = new feedApi();

export default {
  components: {
    InlineSvg,
    GridView,
    TableView,
  },
  data() {
    return {
      posts: [],
      show_loader: false,
      extraFilter: {},
      skip: true,
      pageInfo: {},
      displayGrid: true,
    };
  },
  methods: {
    fetchMorePosts,
    deletePost,
  },
  created() {
    this.fetchMorePosts("");
  },
};

function fetchMorePosts(cursor) {
  this.show_loader = true;
  const POST_QUERY = gql`
      query ($cursor: String!, $extraFilter: PostsFilter!) {
        posts(sort: [CREATED_AT_DESC], first: 15, after: $cursor, filters: $extraFilter) {
          edges {
            node {
              id
              createdAt
              userId
              media {
                id
                croppedUrl
                productTags
              }
              actionCounts
              engagedUsers
              likeCounts
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            endCursor
            startCursor
          }
        }
      }
    `,
    filter =
      this.$session.getUserInfo().role === "ADMIN"
        ? {}
        : {
            userId: this.$session.getUserId(),
          };
  this.$apollo
    .query({
      query: POST_QUERY,
      variables: {
        cursor: cursor,
        extraFilter: filter,
      },
    })
    .then((response) => {
      this.posts = [...this.posts, ...response.data.posts.edges];
      this.pageInfo = response.data.posts.pageInfo;
      this.show_loader = false;
    });
}

async function deletePost(postId) {
  const confirm = await this.$swal({
    title: "Delete Post?",
    showCancelButton: true,
    cancelButtonText: "no",
    confirmButtonText: "yes",
  });

  if (confirm.value) {
    await feedApiService.deletePost(postId);
    this.posts = this.posts.filter((item) => item.node.id !== postId);
  }
}
